// Centralized semantic color tokens for the Admin Dashboard.
// Goal: every component below reads colors from here instead of hardcoding
// hex values, so theme/dark-mode changes only happen in one place.

export const semanticColors = {
  success: "#16a34a",
  warning: "#f59e0b",
  critical: "#dc2626",
  info: "#2563eb",
  neutral: "#64748b",
};

export const attentionSeverityColors: Record<"critical" | "warning" | "info", string> = {
  critical: semanticColors.critical,
  warning: semanticColors.warning,
  info: semanticColors.info,
};

export const trendColors: Record<"up" | "down" | "flat", string> = {
  up: "#16a34a",
  down: "#dc2626",
  flat: "#64748b",
};
